// extracted by mini-css-extract-plugin
module.exports = {"flexRow":"StoreWorkingHours_flexRow__TuoJf","flexColumn":"StoreWorkingHours_flexColumn__K0qGv","days":"StoreWorkingHours_days__DAtAU","times":"StoreWorkingHours_times__htavn"};